import React from "react";
import "./Footer.css";
import { greeting } from "../../portfolio.js";

export default function Footer(props) {
  return (
    <div className="footer-div">
      <p className="footer-text" style={{ color: props.theme.secondaryText }}>
        Made by {greeting.title}
      </p>
      <p className="footer-text" style={{ color: props.theme.secondaryText }}>
        Powered by masterPortfolio @ Github
      </p>
    </div>
  );
}
